/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Mzs_Social_Media14Inputs */

const en__field_enum_mzs_social_media14 = /** @type {(inputs: _Field_Enum_Mzs_Social_Media14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`social media`)
};

const de__field_enum_mzs_social_media14 = /** @type {(inputs: _Field_Enum_Mzs_Social_Media14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Social Media`)
};

/**
* | output |
* | --- |
* | "social media" |
*
* @param {_Field_Enum_Mzs_Social_Media14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_mzs_social_media14 = /** @type {((inputs?: _Field_Enum_Mzs_Social_Media14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Mzs_Social_Media14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_mzs_social_media14(inputs)
	return de__field_enum_mzs_social_media14(inputs)
});
export { _field_enum_mzs_social_media14 as "_field_enum_MZS_SOCIAL_MEDIA" }